import { gql } from '@apollo/client';

export const SUBMIT_TRAIT_ASSESSMENT = gql`
  mutation SubmitTraitAssessment {
    submitTraitAssessment {
      _id
      profile
      confidence
    }
  }
`;

export const SAVE_TRAIT_ASSESSMENT_PROGRESS = gql`
  mutation SaveTraitAssessmentProgress($category: String!, $answers: [TraitAssessmentAnswerInput!]!, $isCompleted: Boolean) {
    saveTraitAssessmentProgress(category: $category, answers: $answers, isCompleted: $isCompleted) {
      _id
      category
      isCompleted
    }
  }
`;